module.exports = __webpack_public_path__ + "static/media/cover-unavaliable-3.0b31b24d.png";